const RulesSection = () => (
  <section id="rules" className="py-10 bg-[#DFB750]">
    <div className="container mx-auto p-10 md:rounded-2xl bg-[#317E70] text-white">
      <h4 className='relative mb-6 text-2xl md:text-3xl font-bold'>
        <span className="absolute -left-4 top-1/2 -translate-y-1/2 w-[6px] h-[28px] bg-[#DFB750]"></span>
        參展須知
      </h4>
      <h6 className='my-3 text-2xl font-bold'>一、獎項以及參考指標</h6>
      <ol className='mb-12 pl-8 list-decimal font-semibold leading-loose'>
        <li>年度最佳場景遊戲：此遊戲中的造景及道具栩栩如生，讓人以視覺觸覺感官身歷其境。精心打造的場景設計不僅具備高度還原性，更能透過細膩的材質與燈光營造，讓玩家完全沉浸在遊戲世界中。</li>
        <li>年度最佳機關遊戲：此遊戲中使用的機關品質與數量兼具，呈現方式具備巧思，讓人有耳目一新的感覺。機關設計邏輯清晰且富有創意，操作手感流暢，每個機關都與主題完美融合，展現製作團隊的技術實力。</li>
        <li>年度最佳劇情遊戲：此遊戲的劇情完整，且遊戲推進節奏得宜，在遊戲結束後仍然能夠讓玩家有餘韻繞樑的感受。故事架構層次分明，角色塑造立體生動，情節轉折自然流暢，讓玩家深度投入其中。</li>
        <li>年度最佳謎題遊戲：此遊戲中出現的謎題具備深度與巧思，並切合該遊戲主題，不會有格格不入的感覺。謎題設計層次豐富，從易到難循序漸進，解謎過程充滿樂趣，讓玩家在思考中獲得成就感。</li>
        <li>年度最佳氣氛遊戲：此遊戲利用演員或是NPC、聲音、燈光、水流煙霧等特效提升氣氛且不突兀。透過精心設計的環境氛圍，成功營造出與主題相符的情境感受，讓玩家完全融入遊戲世界的獨特魅力中。（排除恐怖主題）</li>
        <li>年度最佳恐怖氣氛遊戲：此遊戲利用演員或是NPC、聲音、燈光、水流煙霧等特效提升恐怖氣氛。恐怖元素運用得當，營造出層層遞進的緊張感，讓玩家在驚嚇與刺激中體驗極致的腎上腺素飆升。</li>
        <li>年度最佳創新遊戲：此遊戲的呈現或者進行方式非常創新，在此之前相當少見，並且提升了遊戲可玩性與豐富度。突破傳統框架，引入前所未見的遊戲機制或互動方式，為實境遊戲產業帶來全新的可能性。</li>
        <li>年度最佳精粹密室：秉持著本格密室的規格，讓玩家在有限的時間與空間體驗到精心設計的密室逃脫基本元素，以最純粹的方式呈現密室逃脫的核心樂趣，讓玩家體驗到物超所值的遊戲體驗。（遊戲時長 90 分鐘內且單價 800 元內）</li>
        <li>年度最佳實境解謎：此遊戲讓玩家在實際場域中探索，透過觀察景物來解開謎題，讓玩家能夠在富饒趣味的遊戲過程中對地方的歷史地理或是社會議題有更深刻的了解。</li>
        <li>年度最佳沉浸式劇場：透過精湛的表演技巧與巧妙的互動設計，玩家能夠深度參與劇情發展，在角色扮演中體驗到前所未有的代入感，感受劇場藝術與遊戲的完美融合。</li>
        <li>年度最佳代理遊戲：此遊戲自國外引進，代理商不僅忠實呈現原作精神，更針對在地文化與消費習慣進行細膩的改良，讓國外的創意設計能夠適當融入本土市場，為玩家帶來兼具國際水準與在地特色的優質體驗。</li>
        <li>年度最佳人氣遊戲：不論此遊戲的各面向如何，整體遊玩體驗非常愉快，雖然可能在某些技術層面並非最頂尖，但整體設計均衡，遊戲過程充滿歡樂，讓玩家留下深刻的美好回憶，透過這一票給予肯定。</li>
        <li>年度最佳新秀工作室：不論是設計或者服務都非常值得給予高度期待的新工作室。雖然成立時間不長，但已展現出優秀的創作潛力與專業態度，在遊戲品質與服務水準上都有亮眼表現，值得持續關注。</li>
        <li>年度最佳遊戲：前述 1 - 7 項加總得分最高者。（詳細計算方式見下方第三點）</li>
      </ol>
      <h6 className='my-3 text-2xl font-bold'>二、入圍資格</h6>
      <ol className='mb-12 pl-8 list-decimal font-semibold leading-loose'>
        <li>活動分兩個階段，分別為「資深玩家提名」、「網路公開投票」。</li>
        <li>候選主題資格：在 2024/01/01 ~ 2024/12/31 首次於台灣國內推出並進行公開售票的「密室逃脫」、「實境解謎」、「沉浸式劇場」等遊戲類型皆符合資格。同名異地移植遊戲若首次發行早於 2024 年則不納入資格，惟因大型改版而賦予新的遊戲標題則視為新主題。</li>
        <li>第一階段：2025/7/18 ~ 7/27。由本站邀請 150 位資深玩家就上述 1 至 11 項獎項進行提名。提名期間不即時更新提名狀況。</li>
        <li>公布入圍：2025/7/28 ~ 7/31。以第一階段各獎項被提名次數最多的 3 至 5 款遊戲作為入圍名單。</li>
        <li>第二階段：2025/8/01 ~ 8/10。開放本站 2025 年七月底前完成註冊的玩家進行投票，投票期間即時更新投票狀況。</li>
      </ol>
      <h6 className='my-3 text-2xl font-bold'>三、各獎項計分方式</h6>
      <ol className='mb-12 pl-8 list-decimal font-semibold leading-loose'>
        <li>除「年度最佳遊戲」外，各獎項於第二階段得票最高者即為該獎項得主。</li>
        <li>年度最佳遊戲：只採計「最佳場景」、「最佳機關」、「最佳劇情」、「最佳謎題」、「最佳氣氛」（恐怖或非恐怖，若兩類皆入圍取得分高者計算）、「最佳創新」六項，其餘獎項的得票數不予納入年度最佳遊戲得分。計算方式為入圍的各項目之得票數佔總票數的百分比（除不盡取到小數點第二位）加總之和。因代理遊戲已獨立一獎項，列入年度最佳遊戲僅限本土原創。</li>
        <li>計算範例：某A遊戲入圍「最佳場景」、「最佳機關」、「最佳氣氛」三項，其中「最佳場景」總投票玩家數量為 1,000 人，而A遊戲在「最佳場景」項目獲得 200 票，則A遊戲在「最佳場景」項目的得分為 (200/1000)*100 = 20；又「最佳機關」總投票玩家數量為 1,200 人，而A遊戲在「最佳機關」項目獲得 400 票，則A遊戲在「最佳機關」項目的得分為 (400/1200)*100 = 33.33；又「最佳氣氛」總投票玩家數量為 500人，A遊戲在「最佳氣氛」項目獲得 80 票，則A遊戲在「最佳氣氛」項目的得分為 (80/500)*100 = 16。其餘項目未入圍不予計分，最終得分為 20+33.33+16 = 69.33，以此分數與其他入圍遊戲比總得分。</li>
      </ol>
    </div>
  </section>
);

export default RulesSection;